import { useContext } from 'react'
import { IFrameContext } from 'iframe/store'

export default function useIFrameContext() {
  const iframeRef = useContext(IFrameContext)

  return iframeRef
}
